import appConfig from '@/config/appConfig.typed';
import {getMappedInitialLanguageCode} from '@/services/localization/localizationService';
import {selectDeviceType} from '@/state/selectors/device';
import {getState} from '@/state/store';
import stringUtils from '@/utils/stringUtils';

type SsoTemplateFormatParams = Record<string, unknown>;

type GetFormattedSsoTemplateArgs = {
    ssoTemplate?: string | null;
    params?: SsoTemplateFormatParams;
};

/**
 * Interpolates market, language, device type, and custom params into an ICC SSO template name.
 */
export const getFormattedSsoTemplate = ({ssoTemplate, params}: GetFormattedSsoTemplateArgs): string | null => {
    if (!ssoTemplate) return null;

    const marketCode = appConfig.getIccMarketName?.()?.toUpperCase();
    const languageCode = getMappedInitialLanguageCode()?.toUpperCase();
    const deviceType = selectDeviceType(getState?.())?.toUpperCase();

    if (!languageCode || !marketCode) return null;

    return stringUtils.formatByName(ssoTemplate, {
        marketCode,
        languageCode,
        deviceType,
        ...params,
    });
};
